import { Component, OnInit , AfterViewInit } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-activity-success',
  templateUrl: './activity-success.component.html',
  styleUrls: ['./activity-success.component.css',]
})
export class ActivitySuccessComponent implements OnInit , AfterViewInit {
  submitType: number;
  specialUser: any;
  userType: any;
  constructor(
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
  ) { }

  ngOnInit() {

    this.specialUser = window.sessionStorage.getItem('specialUser');
    this.userType = window.sessionStorage.getItem('userType');
    let _this = this;
    let _submitType = Number(window.sessionStorage.getItem('submitType'));
    if(_submitType){
      _this.submitType = _submitType;
    }else{
      _this.submitType = 1;
    }
  }

    ngAfterViewInit(){
        let html=document.documentElement;
        /*var htmlFontSize=html.clientWidth/7.5;*/
        let htmlFontSize;
        if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }
        html.style.fontSize=htmlFontSize+"px";
        html.style.backgroundColor="rgb(246,247,252)";
    }

  close(){
    window.sessionStorage.removeItem('specialUser');
    let link = ['learning-map'];
    this.router.navigate(link);
  }

}



// WEBPACK FOOTER //
// ./src/app/activity-success/activity-success.component.ts